// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img-container[data-v-58602038]{max-height:120px}.spacing[data-v-58602038]{padding-top:95px;padding-bottom:95px}.header-spacing[data-v-58602038]{display:block;width:100%;padding-top:36px;padding-bottom:20px}.header-spacing h2[data-v-58602038]{font-family:Niveau Grotesk,Roboto,sans-serif;font-size:24px;font-weight:500}.text-spacing[data-v-58602038]{display:block;font-family:Niveau Grotesk;font-size:20px}@media only screen and (max-width:600px){.spacing[data-v-58602038]{padding:20px}}", ""]);
// Exports
module.exports = exports;
